import { Injectable, Injector } from '@angular/core';
import { StateContext, Guid, ImageMessage } from '@lcu/common';
import { ItinerariesState } from './itineraries-state.model';
import { MapMarker, UserMap } from '@lowcodeunit/lcu-map-common';
import { ItineraryModel } from '../../models/itinerary.model';
import { UserAlbum } from '../../models/user-album.model';
import { UserPhoto } from '../../models/user-photo.model';
import { TopListModel } from '../../models/top-list.model';
import { UserInfo } from '../../models/user-info.model';
import { ActivityModel } from '@lowcodeunit/lcu-map-common/lib/models/activity.model';

@Injectable({
  providedIn: 'root',
})
export class ItinerariesStateContext extends StateContext<ItinerariesState> {
  //  Fields
  protected state: ItinerariesState;

  //  Properties

  //  Constructors
  constructor(protected injector: Injector) {
    super(injector);
  }

  //  API Methods

  public AddItinerary(itinerary: ItineraryModel) {
    console.log('inside users state manager... saving itinerary: ', itinerary);

    this.Execute({
      Arguments: {
        Itinerary: itinerary,
      },
      Type: 'AddItinerary',
    });
  }

  // public AddItinerary(itinerary: ItineraryModel) {
  //   console.log('itinerary to save: ', itinerary);

  //   this.Execute({
  //     Arguments: {
  //       Itinerary: itinerary
  //     },
  //     Type: 'AddItinerary'
  //   });
  // }

  public EditItinerary(itinerary: ItineraryModel, activityLocationLookups?: any) {
    console.log('THE ITINERARY: ', itinerary);
    console.log('THE ACTLOCLIST: ', activityLocationLookups);

    this.Execute({
      Arguments: {
        Itinerary: itinerary,
        ActivityLocationLookups: activityLocationLookups
      },
      Type: 'EditItinerary',
    });
  }

  public QuickEditActivity(activity: ActivityModel) {
    console.log('sending to back in "QuickEditActivity: ');
    console.log(activity)
    this.Execute({
      Arguments: {
        Activity: activity,
      },
      Type: 'QuickEditActivity',
    });
  }

  public ItineraryItemOrderAdjusted(itinerary: ItineraryModel, movedActivityId?: string) {

    console.log('sending to back in ItineraryItemOrderAdjusted: ');
    console.log(itinerary)

    this.Execute({
      Arguments: {
        Itinerary: itinerary,
        ActivityChanged: movedActivityId ? movedActivityId : null
      },
      Type: 'ItineraryItemOrderAdjusted',
    });
  }

  public DeleteItineraries(itins: Array<ItineraryModel>) {
    console.log('deleting: ', itins);

    this.Execute({
      Arguments: {
        Itineraries: itins,
      },
      Type: 'DeleteItineraries',
    });
  }

  public DeleteItineraryActivity(itinActivID: any) {
    this.Execute({
      Arguments: {
        ItineraryActivityID: itinActivID,
      },
      Type: 'DeleteItineraryActivity',
    });
  }

  public ShareItineraries(
    itineraries: Array<ItineraryModel>,
    userNames: Array<string>
  ) {
    console.log('Sharing: ', itineraries, ' with ', userNames);

    this.Execute({
      Arguments: {
        Itineraries: itineraries,
        Usernames: userNames,
      },
      Type: 'ShareItineraries',
    });
  }

  //  Helpers
  protected defaultValue() {
    return { Loading: true } as ItinerariesState;
  }

  protected loadStateKey(): string {
    return 'itineraries';
  }

  protected loadStateName(): string {
    return 'amblon';
  }

  protected setupReceiveState(groupName: string) {
    this.rt.RegisterHandler(`ReceiveState=>${groupName}`).subscribe((req) => {
      console.log(`Handled state from ${groupName}`);
 
      this.subject.next(req);
    });
  }
}
